
import {
    GrpcService,
    HttpRequestDelegate,
} from "../grpc"

export interface UploadReportDataRequest {
    deviceSerialNumber?: string /* 设备序列号 */
    examinationId?: number /* 检测ID「由senno-examination-app」模块创建报告得来 */
    balance: UploadBalanceData
    static: UploadStaticData
    dynamic: UploadDynamicData
}

export interface UploadBalanceData {
    footSide: FootSide
    rawDataUrl?: string
}

export interface UploadStaticData {
    rawDataUrl?: string
}

export interface UploadDynamicData {
    rawDataUrl?: string
}

export interface CreateReportResponse {
    ticket: string /* 报告唯一凭证 */
}

export interface CreateReportRequest {
    organizationId?: number /* 登录账号所在的组织ID */
}

export interface ListOrganizationLicenceResponse {
    organizationLicenceList: Array<OrganizationLicence>
}

export interface ListOrganizationLicenceRequest {
    organizationIds: Array<number>
}

export interface UpdateOrganizationLicenceRequest {
    organizationLicence: OrganizationLicence
}

export interface OrganizationLicence {
    organizationId?: number /* 组织ID */
    startTimestamp?: number /* license有效期起始时间 */
    endTimestamp?: number /* license有效期结束时间 */
}

export interface OperateResult {
    done: boolean
}

export enum FootSide {
    FOOT_SIDE_UNKNOWN = 0,
    LEFT = 1,
    RIGHT = 2,
    BOTH = 3,
}

export enum PressureExaminationType {
    PRESSURE_EXAMINATION_TYPE_UNKNOWN = 0,
    BALANCE = 1,
    STATIC = 2,
    DYNAMIC = 3,
}

export class PressureService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /* region licence
 为组织分配权限（使用起始结束时间） */
    async updateOrganizationLicence(request: UpdateOrganizationLicenceRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/pressure.PressureService/UpdateOrganizationLicence"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 查看组织license */
    async listOrganizationLicence(request: ListOrganizationLicenceRequest): Promise<ListOrganizationLicenceResponse> {
        const method = "post"
        const path = "/pressure.PressureService/ListOrganizationLicence"
        return await this.call(method, path, request) as ListOrganizationLicenceResponse
    }
    
    /* region report
 创建报告（需要登陆，即请求头里带"senno-access-token=登录时返回的access token"）） */
    async createReport(request: CreateReportRequest): Promise<CreateReportResponse> {
        const method = "post"
        const path = "/pressure.PressureService/CreateReport"
        return await this.call(method, path, request) as CreateReportResponse
    }
    
    /* 上传报告项（需要登陆，即请求头里带"senno-access-token=登录时返回的access token"）） */
    async uploadReportData(request: UploadReportDataRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/pressure.PressureService/UploadReportData"
        return await this.call(method, path, request) as OperateResult
    }
    
}
